import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import ActionButton from '../ActionButton';
import './styles.scss';

const Schedule = () => {
  const history = useHistory();
  return (
    <>
      <div className="shell-background">
        <div className="hero-layer shell-content hero-centered">
          <div className="container schedule-box hero-centered d-flex align-items-center justify-content-center position-relative flex-column">
            {/* <h1 className=" text-white">Cambio de aceite fácil y rápido</h1> */}
            <div className="row text-white w-100">
              <div className="col-12 text-center">
                {/* <p className="hero-title">Elige dónde, cuándo, tu auto ¡y listo!</p> */}
                <p className="hero-title">Elige dónde, cuándo, tu auto ¡y listo!</p>
                <ActionButton text='¡Agenda aquí!' actionFunction={() => { history.push('/app'); }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Schedule;
